import app from 'flarum/common/app';
app.initializers.add('redundans-external-links-common', () => {
  console.log('[redundans/external-links] Hello, forum and admin!');
});